function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 512 512",
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    d: "M 155.5,-0.5 C 222.167,-0.5 288.833,-0.5 355.5,-0.5C 381.646,8.42696 393.146,26.7603 390,54.5C 385.772,71.0619 375.605,82.2286 359.5,88C 339.888,89.4507 320.221,89.9507 300.5,89.5C 300.5,200.167 300.5,310.833 300.5,421.5C 320.221,421.049 339.888,421.549 359.5,423C 383.49,432.8 393.656,450.633 390,476.5C 384.984,494.682 373.484,506.348 355.5,511.5C 288.833,511.5 222.167,511.5 155.5,511.5C 129.354,502.573 117.854,484.24 121,456.5C 125.228,439.938 135.395,428.771 151.5,423C 171.112,421.549 190.779,421.049 210.5,421.5C 210.5,310.833 210.5,200.167 210.5,89.5C 190.779,89.9507 171.112,89.4507 151.5,88C 127.51,78.2 117.344,60.3667 121,34.5C 126.016,16.3183 137.516,4.65165 155.5,-0.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.bd6b941b06e93b14893143714f394985.svg";
export { ForwardRef as ReactComponent };